// Dnešní směna v tabletu, když není signál (rozhodnutí zadavatele 29. 9. 2026 k 05/1141).
//
// Směnu jde ukončit i bez signálu — odchod čeká ve frontě tabletu (`konec-smeny.ts`). Tablet k tomu ale musí vědět,
// kterou směnu ukončuje (`zaznam.id`) a jaké má řidič nesplněné prioritní úkoly. Proto si poslední **úspěšnou**
// odpověď `GET /dochazka/dnes` uloží do tabletu (IndexedDB) a bez signálu podle ní jen kreslí — stejně jako profil
// `/ja` (`ja-tabletu.ts`). Nic se tím nerozhoduje: odchod z fronty zapíše a ověří server. Při odhlášení se uložená
// směna smaže (na tabletu se může přihlásit někdo jiný).
import { uloziste } from './uloziste';

const KLIC = 'dochazka_dnes';

/** Uloží dnešní směnu ze serveru do tabletu (jen odpověď bez parametru `datum` — tj. opravdu dnešek). */
export function ulozDnesDoTabletu(dnes: unknown): void {
  void uloziste()
    .uloz(KLIC, dnes)
    .catch(() => {
      // Bez trvalého úložiště se směna drží jen v paměti prohlížeče (cache dotazů).
    });
}

/** Dnešní směna uložená v tabletu — jen pro den `datum` (včerejší směna by tvrdila, že je dnešní). */
export async function dnesZTabletu<T extends { datum: string }>(
  datum: string,
): Promise<T | undefined> {
  const ulozena = await uloziste()
    .ziskej<T>(KLIC)
    .catch(() => undefined);
  return ulozena && ulozena.datum === datum ? ulozena : undefined;
}

/**
 * Poslední uložená odpověď o směně, ať je z kteréhokoli dne — z ní si tablet vezme úvazek a to, jestli se účtu docházka
 * počítá, když zahajuje novou směnu bez signálu a dnešek stažený nemá (05/1564). Nic z ní se nevydává za dnešní údaje.
 */
export async function poslednDnesZTabletu<T extends { datum: string }>(): Promise<T | undefined> {
  return uloziste()
    .ziskej<T>(KLIC)
    .catch(() => undefined);
}

/** Odhlášení: uložená směna pryč. */
export async function zapomenDochazkuZTabletu(): Promise<void> {
  await uloziste()
    .smaz(KLIC)
    .catch(() => {});
}
